export default function scrollToElementInVuescroll(
  { node: itemNode },
  vueScrollRef,
  scrollSpeed = 200
) {
  const { offsetTop: nodeTop, offsetHeight: nodeHeight } = itemNode;
  const scrollBounds = vueScrollRef.$el.getBoundingClientRect();
  const { scrollTop } = vueScrollRef.getPosition();
  if (nodeTop < scrollTop) {
    vueScrollRef.scrollTo({ y: nodeTop }, scrollSpeed);
    return;
  }

  if (nodeTop + nodeHeight > scrollBounds.height + scrollTop) {
    vueScrollRef.scrollTo(
      {
        y: nodeTop + nodeHeight - scrollBounds.height,
      },
      scrollSpeed
    );
  }
}
